import React, { useState, useEffect } from 'react';
import { DataTable, Filter, PageWrapper } from '../../components';
import { Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { DriverType, Pages } from '../../shared/enums';
import { useTranslation } from 'react-i18next';
import { getQuizList } from '../../api/quiz';
import dayjs from 'dayjs';
import { DATETIME_FORMAT } from '../../shared/constants';
import { RiAddLargeLine } from 'react-icons/ri';
import Button from '../../components/common/Button';

const Quiz = () => {
    const { t } = useTranslation()
    const navigate = useNavigate();
    const [filter, setFilter] = useState({});
    const [pagination, setPagination] = useState({ page: 1, pageSize: 25 });
    const [totalPages, setTotalPage] = useState(0);
    const [data, setData] = useState([]);

    const handleFilterChange = (newFilter) => {
        setFilter(newFilter);
        setPagination(prev => ({ ...prev, page: 1 })); // Reset to page 1 when filter changes
    };

    const columns = [
        { key: "type", label: t("TYPE"), render: (type, data) => type.join(", "), },
        { key: "question", label: t("QUESTION"), },
        { key: "isPublish", label: t("IS_PUBLISH"), render: (v, data) => data.isPublish.toString(), },
        { key: "createdAt", label: t("CREATED_AT"), render: (createdAt, data) => dayjs(createdAt).format(DATETIME_FORMAT), },
        {
            key: "action", label: t("ACTION"), render: (v, data) => <Dropdown>
                <Dropdown.Toggle variant="primary" size="sm" className='py-0'></Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item onClick={() => navigate(Pages.QuizDetail.replace(":id", data.id))}>{t("EDIT")}</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        }
    ]

    const filters = [
        { type: "input", label: t("SEARCH"), name: "search" },
        { type: "datetime", label: t("FORM_DATE"), name: "fromDate" },
        { type: "datetime", label: t("TO_DATE"), name: "toDate" },
        { type: "select", label: t("TYPE"), name: "type", options: [{ label: "All", value: "" }, ...Object.entries(DriverType).map(([key, value]) => ({ label: t(key), value: value }))] },
    ];

    useEffect(() => {
        getData(pagination, filter)
    }, [pagination, filter])

    const getData = async (pagination, filter) => {
        const response = await getQuizList({ skip: (pagination?.page - 1) * pagination?.pageSize, limit: pagination?.pageSize, ...filter })
        setData(response.items)
        setTotalPage(Math.ceil(response?.pagination?.total / pagination?.pageSize))
    }

    return (
        <PageWrapper
            headerProps={{
                title: "QUIZ",
                rightElement: <Button icon={<RiAddLargeLine />} onClick={() => navigate(Pages.QuizDetail.replace(":id", "new"))}>{t("ADD")}</Button>
            }}
        >
            <Filter filters={filters} onChangeFilter={handleFilterChange} />
            <DataTable columns={columns} data={data} pagination={{ ...pagination, totalPages, onChange: setPagination }} />
        </ PageWrapper>
    );
};

export default Quiz;
